<form
  [formGroup]="formGroup"
  (ngSubmit)="nextStep()"
  class="w-full relative mt-3"
>
  <section class="personalInformation">
    <span class="titleSection">Datos personales</span>
    <div class="grid w-full mb-2 mt-3">
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Apellido/s <span class="span">*</span></label>
        <input
          class="disabled"
          [readOnly]="true"
          pInputText
          formControlName="representative_last_name"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Nombre/s <span class="span">*</span></label>
        <input
          class="disabled"
          [readOnly]="true"
          pInputText
          formControlName="representative_name"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">CUIL<span class="span">*</span></label>
        <input
          class="disabled"
          [readOnly]="true"
          pInputText
          formControlName="representative_cuil"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Correo electronico<span class="span">*</span></label
        >
        <input
          pInputText
          class="disabled"
          [readOnly]="true"
          formControlName="representative_email"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Teléfono</label>
        <input
          placeholder="Teléfono"
          pInputText
          formControlName="representative_phone"
          class="disabled"
          [readOnly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Calle<span class="span">*</span></label>
        <input
          placeholder="Calle"
          type="text"
          maxlength="50"
          class="disabled"
          pInputText
          formControlName="representative_street"
          [readOnly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Número<span class="span">*</span></label>
        <input
          [appNumberOnlyNoLength]="15"
          placeholder="Número"
          type="text"
          pInputText
          formControlName="representative_number"
          maxlength="5"
          class="disabled"
          [readOnly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Piso/Depto</label>
        <input
          placeholder="Piso/Depto"
          type="text"
          pInputText
          formControlName="representative_floor_apartment"
          maxlength="10"
          class="disabled"
          [readOnly]="true"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Torre</label>
        <input
          placeholder="Torre"
          type="text"
          pInputText
          formControlName="representative_tower"
          maxlength="30"
          class="disabled"
          [readOnly]="true"
        />
      </div>

      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Código postal<span class="span">*</span></label
        >
        <input
          [appNumberOnlyNoLength]="15"
          type="text"
          placeholder="Código postal"
          pInputText
          formControlName="representative_postal_code"
          maxlength="10"
          class="disabled"
          [readOnly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle" for="claimetProvince" optionLabel="name"
          >Provincia<span class="span">*</span></label
        >
        <input
          pInputText
          id="representative_province"
          formControlName="representative_province"
          class="disabled"
          [readOnly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Localidad<span class="span">*</span></label>
        <input
          pInputText
          id="representative_city"
          formControlName="representative_city"
          class="disabled"
          [readOnly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle">Persona<span class="span">*</span></label>
        <input
          placeholder="Cargo"
          formControlName="claimantTypePerformance"
          pInputText
          maxlength="50"
          class="disabled"
          [readonly]="true"
        />
      </div>
      <div class="col-12 md:col-4 lg:col-3 xl:col-3 sm:col-6">
        <label class="labelTitle"
          >Departamento laboral<span class="span">*</span></label
        >
        <p-dropdown
          [options]="departments"
          placeholder="Seleccione una opción"
          optionLabel="name"
          optionValue="id"
          formControlName="departmentId"
          [ngClass]="{
            'ng-invalid ng-dirty': hasErrors('departmentId', 'required')
          }"
        />
        <div
          class="text-danger p-error"
          *ngIf="hasErrors('departmentId', 'required')"
        >
          Este campo es obligatorio
        </div>
      </div>
    </div>
  </section>

  <p-divider></p-divider>

  <section class="attachedFiles mt-3">
    <span class="titleSection">Archivos adjuntos</span>
    <div class="grid w-full mt-3">
      <div class="col-12">
        <label class="labelTitle">Documentos</label>
        <p class="descriptionContent mb-0">
          Cargue el documento que acredite la representación que invoca.
        </p>
      </div>

      <div class="col-12 md:col-8 lg:col-8 xl:col-6">
        <div
          [ngClass]="
            isDragging
              ? 'isDragging dropzone-container h-6rem col-12 '
              : 'dropzone-container h-6rem col-12 '
          "
          (dragover)="onDragOver($event)"
          (drop)="onDropSuccess($event, 'receipt')"
        >
          <input
            #inputFilePfd
            type="file"
            multiple="false"
            (change)="onChange($event, 'receipt')"
            accept=".pdf, .jpg, .png"
          />

          <div
            class="w-full flex align-items-center justify-content-between col-12"
          >
            <img
              class="hidden md:block"
              src="../../../../../../../assets/img/main/file-update.svg"
            />
            <span class="descriptionContent hidden md:block"
              >Arrastre sus documentos aquí o</span
            >
            <p-button
              pRipple
              (click)="inputFilePfd.click()"
              #upload
              class="btnUploadFile mr-1"
              >Elegir archivo</p-button
            >
          </div>
        </div>
        <span class="descriptionContent"
          >Archivos permitidos: JPG / JPEG / WEBP / HEIF / PDF / PNG
        </span>
      </div>
      <div class="col-12 md:col-4 lg:col-4 xl:col-6">
        <div
          class="text-danger p-error"
          *ngIf="
            formGroup.get('file')?.hasError('fileCount') &&
            formGroup.get('file')?.touched
          "
        >
          Se deben subir entre 1 y 12 archivos.
        </div>
        <div
          class="conteiner-UploadRight-pdf"
          *ngFor="let pdf of pdfFiles; let i = index"
        >
          <img
            src="../../../../../../../assets/img/main/icon-image.svg"
            alt=""
            class="icon-imagen"
          />
          <span class="descriptionContent">{{ pdf.name }}</span>
          <p-button
            icon="pi pi-times"
            [rounded]="true"
            [text]="true"
            severity="danger"
            (onClick)="deleteFilePfd(i)"
          ></p-button>
        </div>
      </div>
    </div>
  </section>
  <div class="grid w-full flex justify-content-end">
    <div class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        (click)="cancel()"
        label="Cancelar"
        class="btn-cancelar sm:text-xs"
      />
    </div>

    <div class="col-6 md:col-2 lg:col-2 xl:col-2">
      <p-button
        label="Siguiente"
        class="btn-siguiente"
        type="submit"
        [disabled]="formGroup.invalid"
      ></p-button>
    </div>
  </div>
</form>
